// assets/atom-header.js
document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const header = document.querySelector('header.atom-header');
  if (!header) return;

  const menuBtn = header.querySelector('.menu-btn');
  const navList = header.querySelector('.nav-list');
  const overlay = header.querySelector('.atom-header-overlay');
  const logoText = header.querySelector('.atom-header-logo-text');

  const openMenu = () => {
    menuBtn?.classList.add('active');
    navList?.classList.add('active');
    overlay?.classList.add('active', 'side-menu');
    logoText?.classList.add('active');
    root.classList.add('disable-scrolling');
    menuBtn?.setAttribute('aria-expanded', 'true');
  };

  const closeMenu = () => {
    menuBtn?.classList.remove('active');
    navList?.classList.remove('active');
    overlay?.classList.remove('active', 'side-menu');
    logoText?.classList.remove('active');
    root.classList.remove('disable-scrolling');
    menuBtn?.setAttribute('aria-expanded', 'false');
  };

  menuBtn?.addEventListener('click', () => {
    const expanded = menuBtn.getAttribute('aria-expanded') === 'true';
    expanded ? closeMenu() : openMenu();
  });

  overlay?.addEventListener('click', closeMenu);
  window.addEventListener('keyup', (e) => { if (e.key === 'Escape') closeMenu(); });

  // Mobile submenu toggles
  header.querySelectorAll('.mobile-submenu-dropdown-toggle').forEach(t => {
    t.addEventListener('click', (e) => {
      e.preventDefault();
      const li = t.closest('li');
      if (li?.classList.contains('has-submenu')) {
        li.classList.toggle('show-submenu');
      }
    });
  });
});